'use client';

import { type ShowType } from '@/features/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { FormControlLabel } from '@andritzot/metris-web-ui/inputs/form-control';
import { Switch } from '@andritzot/metris-web-ui/inputs/switch';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface ShowTypeSelectionProps {
  onChange: (value: ShowType[]) => void;
  showType: ShowType[];
}

const OPTIONS: Array<{ label: ShowType; description: string }> = [
  { label: 'Show Solutions', description: 'Products' },
  { label: 'Show Components', description: 'Components' },
];

const ShowTypeSelection = ({ onChange, showType }: ShowTypeSelectionProps) => {
  const handleChange = (option: ShowType, checked: boolean) => {
    const nextValue = checked ? [...showType, option] : showType.filter((value) => value !== option);

    onChange(nextValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 4,
      }}
    >
      {OPTIONS.map(({ label, description }) => (
        <FormControlLabel
          key={label}
          control={
            <Switch
              checked={showType.includes(label)}
              onChange={(_, checked) => handleChange(label, checked)}
              size="small"
            />
          }
          label={<Typography variant="body2">{description}</Typography>}
        />
      ))}
    </Box>
  );
};

export default ShowTypeSelection;
